{
  "add": "Добавить агента",
  "addFirst": "Добавить первого агента",
  "emptyTitle": "Агентов пока нет",
  "emptyHint": "Агент ставится один раз на площадку и подключается к платформе исходящим соединением. Ни проброс портов, ни VPN, ни белый IP для этого не нужны, а на управляемые машины ничего не устанавливается.",
  "loadFailed": "Не удалось загрузить агентов",
  "loadFailedHint": "{{reason}} Проверьте связь с сервером.",
  "editAria": "Изменить агента {{name}}",
  "editTitle": "Изменить название и площадки",
  "updateAria": "Обновить агента {{name}}",
  "deleteAria": "Удалить агента {{name}}",
  "deleteTitle": "Удалить агента",
  "deleteConfirm": "Удалить агента «{{name}}»? Его площадки останутся без агента, и узлы на них будут доступны только напрямую.",
  "rotateConfirm": "Выпустить новый токен для «{{name}}»? Прежний доступ будет отозван, а работающий агент отключится.",
  "pickAgent": "Выберите агента, чтобы увидеть команду установки и проверить туннель.",
  "noSites": "нет площадок",
  "column": {
    "name": "Агент",
    "platform": "Платформа",
    "version": "Версия",
    "update": "Обновление",
    "sites": "Площадки",
    "lastSeen": "Контакт"
  },
  "info": {
    "label": "Про агентов и сборки",
    "onePerSite": "Агент подключается сам, исходящим соединением. Он может обслуживать несколько площадок сразу, если они в одной сети; двух агентов на одной площадке платформа не допускает — они выполняли бы одни и те же проверки дважды.",
    "catalogAvailable": "Каталог сборок доступен, последняя — {{version}}.",
    "catalogMissing": "Автообновление не настроено: каталог сборок агента платформе недоступен, обновлять агентов придётся вручную."
  },
  "update": {
    "failed": "не обновился до {{version}}",
    "disabled": "обновление выключено",
    "behind": "отстал: есть {{version}}",
    "behindDisabled": "есть {{version}}, выключено",
    "current": "актуален",
    "currentDisabled": "актуален, обновление выключено"
  },
  "updateNow": {
    "offline": "Агент не подключён: обновлять нечего",
    "noCatalog": "Каталог сборок агента не настроен",
    "upToDate": "Агент уже нужной версии",
    "action": "Обновить до {{version}} сейчас"
  },
  "status": {
    "online": "Подключён",
    "offline": "Не подключён",
    "never": "Ни разу не подключался"
  },
  "lastSeen": {
    "never": "не подключался",
    "live": "на связи"
  },
  "form": {
    "name": "Имя агента",
    "nameHint": "как он виден в списке",
    "nameHintNew": "как он будет виден в списке",
    "sites": "Площадки",
    "siteTaken": "Уже обслуживает агент «{{name}}»",
    "pickSites": "— выберите площадки —",
    "sitesHintNew": "можно отметить несколько",
    "noSitesYet": "Площадок пока нет",
    "autoUpdate": "Обновлять автоматически",
    "autoUpdateHint": "Платформа предложит обновиться, когда в каталоге сборок появится версия новее. Обновление в разгар смены — решение администратора",
    "movingNote": "Агент возьмёт на себя мониторы отмеченных площадок и перестанет обслуживать снятые. Соединение при этом не прервётся."
  },
  "install": {
    "title": "Установка агента {{name}}",
    "intro": "Агент ставится один раз в сети площадки и подключается исходящим соединением. На управляемые машины ничего устанавливать не нужно.",
    "tokenTitle": "Одноразовый токен · показывается один раз",
    "tokenShownOnce": "Токен был показан при создании и больше не хранится в открытом виде.",
    "alreadyEnrolled": "Агент уже зарегистрирован. Новый токен нужен только при переустановке.",
    "issuing": "Выпускаем…",
    "issueToken": "Выпустить новый токен",
    "rotateNote": "Прежний доступ при этом отзывается, а работающий агент отключается.",
    "commandTitle": "Команда установки · {{platform}}",
    "copyCommand": "Скопировать команду",
    "tokenPlaceholder": "<одноразовый-токен>",
    "download": {
      "title": "Файлы для установки",
      "agent": "Скачать агента {{version}} · {{size, bytes}}",
      "script": "Скачать скрипт установки",
      "working": "Скачиваем…",
      "unavailable": "Сборки для этой платформы у платформы нет: каталог сборок пуст или собран без неё. Бинарник придётся взять у поставщика платформы.",
      "platform": {
        "linux/amd64": "Linux · x86-64",
        "linux/arm64": "Linux · ARM64",
        "windows/amd64": "Windows · x64"
      }
    }
  },
  "probe": {
    "title": "Проверка туннеля",
    "host": "Адрес устройства",
    "port": "Порт",
    "test": "Проверить",
    "testing": "Проверяем…",
    "offline": "агент не подключён — проверка недоступна",
    "connecting": "устанавливаем соединение…",
    "ok": "соединение установлено за {{ms}} мс",
    "hint": "адрес и порт устройства в сети площадки"
  }
}
